export { default as CategoriesIndexTableHeader } from './CategoriesIndexTableHeader';
